import { useContext, useEffect } from "react";
import { isEmpty } from "lodash";
import { Table } from "react-bootstrap";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import CustomModal from "../../../helpers/CustomModal/CustomModal";

import { areYouSureMessage } from "../../../utils/toastMessage/toastMessage";

import EmptyItems from "../../../helpers/EmptyItems/EmptyItems";
import UploadMedia from "./../../../helpers/UploadMedia/UploadMedia";
import { menuAdminContext } from "../../../context/Admin/MenuAdminContext/MenuAdminContext";
import { menuImage } from "../../../utils";
import { useSelector } from "react-redux";

const MenuAdmin = () => {
  const setting = useSelector((state) => state.meta?.setting);

  const {
    image,
    setImage,
    title,
    setTitle,
    description,
    setDescription,
    price,
    setPrice,
    subCategoryId,
    setSubCategoryId,
    menuId,
    menus,
    subCategories,
    isPapular,
    setIsPapular,
    isShowModal,
    showModal,
    closeModal,
    handleGetSubCategories,
    handleCreateMenu,
    handleGetMenus,
    handleEditMenu,
    handleDeleteMenu,
  } = useContext(menuAdminContext);

  useEffect(() => {
    handleGetSubCategories();
    handleGetMenus();
  }, []);

  return (
    <>
      <SiteTitle title="مدیریت منو" />

      <div className="container-fluid mt-4">
        <button
          type="button"
          className="kf-btn mb-3"
          onClick={() => showModal(null)}
        >
          <span>افزودن آیتم</span>
        </button>

        {isEmpty(menus) ? (
          <EmptyItems />
        ) : (
          <div className="card">
            <Table responsive hover>
              <thead>
                <tr>
                  <th>#</th>
                  <th>تصویر</th>
                  <th>عنوان</th>
                  <th>توضیحات</th>
                  <th>قیمت</th>
                  <th>محبوب</th>
                  <th>زیر دسته</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {menus.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>
                      <img
                        src={menuImage(item.image, setting.logo)}
                        style={{ width: 50, height: 50 }}
                        alt={item.title}
                      />
                    </td>
                    <td>{item.title}</td>
                    <td>{item.description}</td>
                    <td>{item.price}</td>
                    <td>
                      {item.isPapular ? (
                        <i className="la la-check text-success" />
                      ) : (
                        <i className="la la-times text-danger" />
                      )}
                    </td>
                    <td>{item.subCategory?.title}</td>
                    <td>
                      <button
                        type="button"
                        className="btn-primary mx-2"
                        onClick={() => showModal(item)}
                      >
                        ویرایش
                      </button>
                      <button
                        type="button"
                        className="btn-danger mx-2"
                        onClick={() =>
                          areYouSureMessage(
                            () => handleDeleteMenu(item._id),
                            `آیا از حذف ${item.title} مطمئنید؟`,
                          )
                        }
                      >
                        حذف
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
      </div>
      {/* Start Add OR Edit Modal */}
      <CustomModal
        size="lg"
        title={`${menuId ? "ویرایش" : "افزودن"} آیتم منو`}
        show={isShowModal}
        onHide={closeModal}
      >
        <form onSubmit={menuId ? handleEditMenu : handleCreateMenu}>
          <div className="row">
            <div className="col-12">
              <div className="row">
                <div className="col-12 col-md-6 col-lg-3">
                  <UploadMedia callback={(val) => setImage(val)} />
                </div>
                <div className="col-12 col-md-6 col-lg-9">
                  <div className="kf-field">
                    <input
                      type="text"
                      name="image"
                      placeholder="تصویر"
                      onChange={(e) => setImage(e.target.value)}
                      value={image}
                    />
                    <i className="la la-image" />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="kf-field">
                <select
                  type="text"
                  name="image"
                  onChange={(e) => setSubCategoryId(e.target.value)}
                >
                  <option selected disabled hidden value="">
                    لطفا زیر دسته را انتخاب کنید
                  </option>
                  {subCategories.map((item) => (
                    <option
                      className="bg-dark"
                      key={item._id}
                      value={item._id}
                      selected={item._id === subCategoryId}
                    >
                      {item.category?.title} - {item.title}
                    </option>
                  ))}
                </select>
                <i className="la la-list-alt" />
              </div>
            </div>

            <div className="col-12 col-md-6">
              <div className="kf-field">
                <input
                  type="text"
                  name="title"
                  placeholder="عنوان"
                  onChange={(e) => setTitle(e.target.value)}
                  value={title}
                />
                <i className="la la-file" />
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="kf-field">
                <input
                  type="text"
                  name="description"
                  placeholder="توضیحات"
                  onChange={(e) => setDescription(e.target.value)}
                  value={description}
                />
                <i className="la la-file-alt" />
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="kf-field">
                <input
                  type="text"
                  name="price"
                  placeholder="قیمت"
                  onChange={(e) => setPrice(e.target.value)}
                  value={price}
                />
                <i className="la la-money-bill" />
              </div>
            </div>
            <div className="col-12 col-md-6">
              <button
                type="button"
                onClick={() => setIsPapular(!isPapular)}
                className={`btn btn-${
                  isPapular ? "primary" : "secondary"
                } px-5`}
              >
                محبوب
              </button>
            </div>
          </div>

          <div className="kf-bts mt-4">
            <button className="kf-btn" type="submit">
              <span>{menuId ? "ویرایش" : "اضافه"}</span>
            </button>

            <button
              type="button"
              className="btn btn-danger me-2"
              onClick={closeModal}
            >
              انصراف
            </button>
          </div>
        </form>
      </CustomModal>
      {/* End Add OR Edit Modal */}
    </>
  );
};

export default MenuAdmin;
